/**
 * Chapter023.js — Hazard Reporting (OHSE 023)
 * Migrated from SWMS Platform Chapter023.tsx → JavaScript
 *
 * Static policy chapter — hazard reporting procedures.
 * No user-editable data fields; company name is the only variable.
 *
 * Props:
 *   companyName {string}  from companyInfo.name
 */

function Co({ cn }) {
  return <span className="font-semibold text-[#c9a84c]">{cn}</span>;
}

export default function Chapter023({ companyName }) {
  const cn = companyName || '[Company Name]';

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">OHSE 023</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">
          Hazard Reporting
        </h2>
      </div>

      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <div className="px-4 py-2.5 bg-[#f0ede6]">
          <h3 className="text-sm font-semibold text-[#1a1a2e] uppercase tracking-wide">
            Hazard Reporting Policy
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Procedures for reporting and managing workplace hazards
          </p>
        </div>
        <div className="p-6 space-y-4 text-sm text-[#1a1a2e] leading-relaxed">
          <p>
            <Co cn={cn} /> encourages all employees to report hazards{' '}
            <span className="underline">immediately</span> to the Works Supervisor.
          </p>

          <p>
            Where the hazard cannot be corrected immediately,{' '}
            <Co cn={cn} /> records the details of the hazard in the Hazard Register.
          </p>

          <p>
            <Co cn={cn} /> investigates all reported hazards and implements control measures
            to eliminate and/or minimise the likelihood of an incident or injury.
          </p>

          <p>
            <Co cn={cn} /> identifies a risk class/ranking for all hazards by referring to
            the categories ranging from high to low in the Risk Matrix. The Risk Matrix is used
            to determine the level of danger or seriousness (i.e. the consequence) of the risk,
            how likely it is that this risk will occur (i.e. likelihood/probability) and therefore
            how detailed control measures will need to be to eliminate or minimise the risk.
          </p>

          <p>
            <Co cn={cn} /> regularly reviews and evaluates the effectiveness of control measures
            until the hazard is addressed and/or all risks have been mitigated or reduced.
          </p>

          <p>
            <Co cn={cn} /> will issue a copy of any completed Hazard Report form to the principal
            contractor, as required.
          </p>

          <p className="text-xs text-gray-400 pt-2 border-t border-[#e0dbd0]">
            This content is a standard policy template. Company name is derived from Settings.
          </p>
        </div>
      </div>
    </div>
  );
}
